import React, { useState } from 'react';
import { NavigationProvider } from './lib/navigation/navigation';
import { RouterConfig } from './lib/navigation';
import { AppContext } from './lib/app/app.context';
import { AppContextInterface, SimpleSession } from './lib/app/app.interface';
import { makeRoutes } from './lib/navigation/routes';
import { authInterceptor } from './lib/auth/auth.interceptor';
import Swal from "sweetalert2";
import withReactContent from 'sweetalert2-react-content';
import { ApiConfig } from './lib/api/api.config';

export const LoginBanner: React.FC<{ setSession }> = ({
    setSession
}) => {
    const [access, setAccess] = useState("");

    return (<div>
        <div className="mb-3">
            <label className="form-label d-flex float-left">Clave de acceso</label>
            <input type='password' className='form-control' onChange={e => setAccess(e.target.value)}/>
            <button className='btn btn-primary mt-2'
                onClick={() => {
                    if(access==="@@rosaritos2025"){
                        const newSession = { auth_token: ApiConfig.PUBLIC };
                        localStorage.setItem("log-ops-session", JSON.stringify(newSession))
                        setSession(newSession)
                        Swal.close()
                    } else {
                        window.location.reload();
                    }
                }}
            >Continuar</button>
        </div>
    </div>)
}

const App: React.FC = () => {
    const swal = withReactContent(Swal);
    const [session, setSession] = useState(
        JSON.parse(localStorage.getItem("log-ops-session") || '{}')
    );
    
    if(!session.auth_token){
        swal.fire({
            title: 'Acceso restringido',
            html: <LoginBanner setSession={setSession}/>,
            showConfirmButton: false
        })
    }

    const appContext: AppContextInterface = { 
        session, setSession,
    }    
    
    return (
       <AppContext.Provider value={appContext}>
            {session && session.auth_token && <NavigationProvider 
                routes={
                    makeRoutes<SimpleSession>(
                        RouterConfig, authInterceptor, session
                    )
                }
            >
            </NavigationProvider>}
        </AppContext.Provider>
    );
};

export default App;
